// The display half of the lesson-kind table. Separate from lessons.ts's
// KIND_RULES so progress.ts can read the rules without reaching a UI module
// or a string catalog.

import type { LessonKind } from "@aybuben/core/content/types.ts";
import {
	BookOpen,
	Dumbbell,
	Flag,
	Headphones,
	History,
	Languages,
	type LucideIcon,
} from "lucide-react";

import type { UiKey } from "../i18n/index.tsx";

export interface LessonKindUi {
	icon: LucideIcon;
	nameKey: UiKey;
}

export const KIND_UI: Record<LessonKind, LessonKindUi> = {
	learn: { icon: BookOpen, nameKey: "lesson.kind.learn" },
	drill: { icon: Dumbbell, nameKey: "lesson.kind.drill" },
	listen: { icon: Headphones, nameKey: "lesson.kind.listen" },
	words: { icon: Languages, nameKey: "lesson.kind.words" },
	review: { icon: History, nameKey: "lesson.kind.review" },
	checkpoint: { icon: Flag, nameKey: "lesson.kind.checkpoint" },
};
